import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NavigationComponent } from './header-navigation/navigation.component';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { SpinnerComponent } from './spinner.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AgGridModule } from 'ag-grid-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { TagInputModule } from 'ngx-chips';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { ToastrModule } from 'ngx-toastr';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 1,
  wheelPropagation: true,
  minScrollbarLength: 20
};   

@NgModule({
  declarations: [
   SidebarComponent,
   NavigationComponent,
   BreadcrumbComponent,
   SidebarComponent,
   SpinnerComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    PerfectScrollbarModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    TagInputModule,
    AgGridModule.withComponents([]),
    AngularSlickgridModule.forRoot(),
    ToastrModule.forRoot()
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  exports: [
    SidebarComponent,
    NavigationComponent,
    BreadcrumbComponent,
    CommonModule,
    NgbModule,
    PerfectScrollbarModule,
    RouterModule,
    SpinnerComponent,
    FormsModule,
    ReactiveFormsModule,
    AgGridModule,
    NgSelectModule,
    TagInputModule,
    AngularSlickgridModule,
    ToastrModule
  ]
})
export class SharedModule { }
